import { z } from 'zod';
/**
 * Umumiy validatsiya qoidalari — frontend va backend bitta manbadan foydalanadi,
 * shunda ikki joyda ikki xil tekshiruv bo'lib qolmaydi.
 */
/** O'zbekiston telefon raqami: 998XXXXXXXXX (12 raqam, `+` va probelsiz). */
export const phoneSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/\D/g, ''))
    .pipe(z
    .string()
    .regex(/^998\d{9}$/, 'v.phone'));
/** JSHSHIR (PINFL) — 14 raqam. */
export const pinflSchema = z
    .string()
    .trim()
    .regex(/^\d{14}$/, 'v.pinfl');
/** Pasport seriyasi va raqami: AA1234567. */
export const passportSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{2}\d{7}$/, 'v.passport');
/** Karta raqami — 16 raqam (UzCard/Humo). */
/**
 * Karta raqamining nazorat yig'indisi (Luhn).
 *
 * Bu OGOHLANTIRISH uchun, taqiq uchun emas: bitta raqami xato terilgan
 * karta 16 xonali bo'lib qolaveradi va xato provayderda, PULLIK
 * identifikatsiyadan KEYIN chiqadi («invalid pan», jonli mijoz 25.08).
 *
 * Nega taqiq emas: barcha mahalliy kartalar shu qoidaga bo'ysunishiga
 * ishonchimiz komil emas, va yanglishsak — haqiqiy mijozni butunlay
 * to'sib qo'yardik. Ogohlantirish esa hech narsani buzmaydi.
 */
export function isValidPan(pan) {
    const digits = pan.replace(/\D/g, '');
    if (digits.length !== 16)
        return false;
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
        let digit = Number(digits[digits.length - 1 - i]);
        if (i % 2 === 1) {
            digit *= 2;
            if (digit > 9)
                digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 === 0;
}
export const panSchema = z
    .string()
    .trim()
    .transform((v) => v.replace(/\s/g, ''))
    .pipe(z.string().regex(/^\d{16}$/, 'v.pan'));
/**
 * Karta amal qilish muddati — 4 raqam.
 *
 * TODO(mijoz): BT §6.3.1 da namuna `"1230"` berilgan, lekin format MMYY yoki
 * YYMM ekani aniqlanmagan. Alif va Uzum bilan tasdiqlash kerak — noto'g'ri
 * tartib barcha kartalarni rad etilishiga olib keladi.
 */
export const cardExpirySchema = z
    .string()
    .trim()
    .regex(/^\d{4}$/, 'v.cardExpiry');
export const cardSchema = z.object({
    pan: panSchema,
    expiry: cardExpirySchema,
});
/** IKPU — tovar tasnifi kodi, 17 belgi (BT §6.6.1). */
export const ikpuSchema = z
    .string()
    .trim()
    .regex(/^\d{17}$/, 'v.ikpu');
/** Tiyindagi summa — musbat butun son. */
export const tiyinSchema = z
    .number()
    .int('v.amountInt')
    .positive('v.amountPositive');
/** ISO sana: YYYY-MM-DD. */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'v.isoDate');
/** Sahifalash parametrlari. */
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
/**
 * Yangi parol uchun talab.
 *
 * Kirishdagi tekshiruvdan (`loginRequestSchema`) qattiqroq: eski
 * parollar qisqa bo'lishi mumkin va ular bilan kirish ishlashda davom
 * etadi, lekin YANGI parol zaif bo'lmasligi kerak.
 */
export const newPasswordSchema = z
    .string()
    .min(8, 'v.passwordWeak')
    .max(72, 'v.passwordLong');
//# sourceMappingURL=common.js.map